// crypto.randomUUID is only defined in secure contexts (HTTPS or localhost).
// Customers reach the standalone over plain http://<ip>:8080 where it is
// undefined; fall back to a v4-shaped id from Math.random so chat still works.
export function randomUUID(): string {
  const c = typeof crypto !== "undefined" ? crypto : undefined;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  const rnd = (n: number) => Math.floor(Math.random() * n);
  const hex = (n: number, len: number) => n.toString(16).padStart(len, "0");
  return (
    hex(rnd(0x100000000), 8) + "-" +
    hex(rnd(0x10000), 4) + "-" +
    hex(0x4000 | rnd(0x1000), 4) + "-" +
    hex(0x8000 | rnd(0x4000), 4) + "-" +
    hex(rnd(0x100000000), 8) + hex(rnd(0x10000), 4)
  );
}
